import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';


export default function MinAndMax() {
  return <Stack spacing={2}  direction="row">
    <TextField id="form-min" label="Min *" variant="outlined"/>
    <TextField id="form-max" label="Max *" variant="outlined"/>
  </Stack>
}